import { computed, ref, Ref } from 'vue';
import { ICustomSkeleton } from './ICustomSkeleton';

export class SkeletonCB {
	private readonly customWidth: string | undefined;
	private readonly customHeight: string | undefined;

	public readonly background: string;
	public readonly active: Ref<boolean>;
	public skeletonRef = ref<HTMLElement | null>(null);

	public inactive = computed(() => !this.active.value);
	public lightBackground = computed(() => this.background === 'Light');
	public darkBackground = computed(() => this.background === 'Dark');

	public constructor(active: Ref<boolean>, background: 'Light' | 'Dark', custom: ICustomSkeleton | undefined) {
		this.active = active;
		this.background = background;
		this.customWidth = custom?.customWidth;
		this.customHeight = custom?.customHeight;
	}

	public mounted(): void {
		if (!this.skeletonRef.value) {
			return;
		}

		if (this.customWidth) {
			this.skeletonRef.value.style.width = this.customWidth;
		}
		if (this.customHeight) {
			this.skeletonRef.value.style.height = this.customHeight;
		}
	}
}
